export enum MeterTypeEnum {
  BTM = 'BTM',
  FTM = 'FTM',
}
